import CalendarItemUser from "./CalendarItemUser";

import Dropdown from "../../components/Dropdown";

import { CALENDAR_PERMISSIONS } from "../js/constants";

export default ({
  id,
  name,
  lastName,
  pic,
  calendarColor,
  permission,
  onChangePermission,
  readOnly,
}) => {
  return (
    <div className="popup-calendar-contenido-user">
      <CalendarItemUser
        icon={pic}
        name={name}
        lastName={lastName}
        calendarColor={calendarColor}
        readOnly={false}
        onClick={null}
      />
      <div className="dummy-button-text personName">
        {name + " " + lastName}
      </div>
      <Dropdown
        id={"permission-types" + id}
        tabIndex={105}
        optionList={CALENDAR_PERMISSIONS}
        size={1}
        op={permission.id}
        onChange={(e) => {
          onChangePermission(e);
        }}
        disabled={readOnly}
      />
    </div>
  );
};
